export default __webpack_public_path__ + "static/media/Punto_09_Mercato_Centrale_SPA_Def.5913fcff.aac";